import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "evCharger"
const EvChargerIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path d="m8.444 18.32 2.05-3.32H9.258v-2.49l-2.026 3.32h1.21v2.49Zm-2.725-8.016h6.264V4.897H5.72v5.407Zm0 8.822h6.264v-7.399H5.72v7.4ZM3.88 21V4.897c0-.522.18-.968.536-1.34A1.74 1.74 0 0 1 5.72 3h6.264c.513 0 .951.186 1.316.557.365.372.547.818.547 1.34v7.139h1.7c.342 0 .633.122.873.367.241.245.361.534.361.866v5.265c0 .316.124.577.373.782.248.206.535.309.861.309.342 0 .66-.103.955-.309.295-.205.443-.466.443-.782v-9.32h-.257a.875.875 0 0 1-.652-.261.909.909 0 0 1-.256-.664V5.964h.466V4.708h.885v1.256h.908V4.708h.908v1.256h.466V8.29c0 .268-.09.49-.268.664a.886.886 0 0 1-.64.26h-.256v9.32c0 .712-.272 1.301-.815 1.767a2.81 2.81 0 0 1-1.887.7c-.698 0-1.3-.233-1.804-.7-.505-.466-.757-1.055-.757-1.766v-5.265c0 .031.008.055.023.07.016.017.04.025.07.025h-1.7V21H3.88Zm8.104-1.873H5.72h6.264Z" />
        </svg>
      }
    </span>
  )
}
export default EvChargerIcon
